// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Data9 from "common/src/data/Data9.bs.js";
import * as React from "react";
import * as Data10 from "common/src/data/Data10.bs.js";
import * as Data11 from "common/src/data/Data11.bs.js";
import * as Data12 from "common/src/data/Data12.bs.js";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as Data14 from "common/src/data/Data14.bs.js";
import * as Data15 from "common/src/data/Data15.bs.js";
import * as Data16 from "common/src/data/Data16.bs.js";
import * as Data17 from "common/src/data/Data17.bs.js";
import * as Data18 from "common/src/data/Data18.bs.js";
import * as Data36 from "common/src/data/Data36.bs.js";
import * as Data46 from "common/src/data/Data46.bs.js";
import * as Data56 from "common/src/data/Data56.bs.js";
import * as Data76 from "common/src/data/Data76.bs.js";
import * as Data95 from "common/src/data/Data95.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TbItemCell from "./TbItemCell.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function TbCraftableItemsGrid(Props) {
  var search = Props.search;
  var searchItems = Props.searchItems;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return [];
      });
  var setItemFilters = match[1];
  var itemFilters = match[0];
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex pb-2 pl-[1px]"
                }, Belt_Array.map(Belt_Array.range(1, 9), (function (i) {
                        var op = itemFilters.includes(i) ? "" : "opacity-30";
                        var match = Belt_Array.getExn(Data12.itemsArr(), i - 1 | 0);
                        var tmp = {
                          size: 22,
                          search: search,
                          itemId: match[0]
                        };
                        if (searchItems !== undefined) {
                          tmp.searchItems = Caml_option.valFromOption(searchItems);
                        }
                        return React.createElement("div", {
                                    key: String(i),
                                    className: "cursor-pointer flex justify-center w-[33px] " + op,
                                    onClick: (function (param) {
                                        return Curry._1(setItemFilters, (function (itemFilters) {
                                                      if (itemFilters.includes(i)) {
                                                        return Belt_Array.keep(itemFilters, (function (itemId) {
                                                                      return itemId !== i;
                                                                    }));
                                                      } else {
                                                        return Belt_Array.concat(itemFilters, [i]);
                                                      }
                                                    }));
                                      })
                                  }, React.createElement(TbItemCell.make, tmp));
                      }))), React.createElement("div", {
                  className: "border-l border-t border-white1"
                }, Belt_Array.map(Belt_Array.range(1, 9), (function (i) {
                        return React.createElement("div", {
                                    key: String(i),
                                    className: "flex"
                                  }, Belt_Array.map(Belt_Array.range(1, 9), (function (j) {
                                          var isVisible = itemFilters.length === 0 || itemFilters.includes(i) || itemFilters.includes(j);
                                          var tmp = true;
                                          if (itemFilters.length !== 0) {
                                            var tmp$1;
                                            switch (j) {
                                              case 7 :
                                                  tmp$1 = 9;
                                                  break;
                                              case 8 :
                                                  tmp$1 = j + 1 | 0;
                                                  break;
                                              case 9 :
                                                  tmp$1 = 8;
                                                  break;
                                              default:
                                                tmp$1 = j + 1 | 0;
                                            }
                                            tmp = itemFilters.includes(tmp$1);
                                          }
                                          var isRightVisible = tmp || itemFilters.includes(i);
                                          var isBottomVisible = true;
                                          if (!(itemFilters.length === 0 || itemFilters.includes(j))) {
                                            var tmp$2;
                                            switch (i) {
                                              case 7 :
                                                  tmp$2 = 9;
                                                  break;
                                              case 8 :
                                                  tmp$2 = i + 1 | 0;
                                                  break;
                                              case 9 :
                                                  tmp$2 = 8;
                                                  break;
                                              default:
                                                tmp$2 = i + 1 | 0;
                                            }
                                            isBottomVisible = itemFilters.includes(tmp$2);
                                          }
                                          var match;
                                          if (set >= 111) {
                                            match = set >= 150 ? (
                                                set >= 170 ? (
                                                    set !== 180 ? (
                                                        set >= 171 ? Data15.gridItem(i, j) : Data17.gridItem(i, j)
                                                      ) : Data18.gridItem(i, j)
                                                  ) : (
                                                    set !== 160 ? Data15.gridItem(i, j) : Data16.gridItem(i, j)
                                                  )
                                              ) : (
                                                set !== 120 ? (
                                                    set !== 130 ? (
                                                        set !== 140 ? Data15.gridItem(i, j) : Data14.gridItem(i, j)
                                                      ) : Data13.gridItem(i, j)
                                                  ) : Data12.gridItem(i, j)
                                              );
                                          } else if (set >= 56) {
                                            if (set >= 90) {
                                              if (set >= 101) {
                                                match = set >= 110 ? Data11.gridItem(i, j) : Data15.gridItem(i, j);
                                              } else {
                                                switch (set) {
                                                  case 90 :
                                                      match = Data9.gridItem(i, j);
                                                      break;
                                                  case 95 :
                                                      match = Data95.gridItem(i, j);
                                                      break;
                                                  case 91 :
                                                  case 92 :
                                                  case 93 :
                                                  case 94 :
                                                  case 96 :
                                                  case 97 :
                                                  case 98 :
                                                  case 99 :
                                                      match = Data15.gridItem(i, j);
                                                      break;
                                                  case 100 :
                                                      match = Data10.gridItem(i, j);
                                                      break;
                                                  
                                                }
                                              }
                                            } else {
                                              match = set !== 76 ? (
                                                  set >= 57 ? Data15.gridItem(i, j) : Data56.gridItem(i, j)
                                                ) : Data76.gridItem(i, j);
                                            }
                                          } else {
                                            match = set !== 10 ? (
                                                set !== 36 ? (
                                                    set !== 46 ? Data15.gridItem(i, j) : Data46.gridItem(i, j)
                                                  ) : Data36.gridItem(i, j)
                                              ) : Data10.gridItem(i, j);
                                          }
                                          var c1 = {
                                            NAME: "rgba",
                                            VAL: [
                                              255,
                                              255,
                                              255,
                                              {
                                                NAME: "num",
                                                VAL: 0.87
                                              }
                                            ]
                                          };
                                          var c2 = {
                                            NAME: "rgba",
                                            VAL: [
                                              255,
                                              255,
                                              255,
                                              {
                                                NAME: "num",
                                                VAL: 0.4
                                              }
                                            ]
                                          };
                                          var tmp$3 = {
                                            search: search,
                                            itemId: match[0],
                                            key: String(Math.imul(i, 10) + j | 0)
                                          };
                                          if (searchItems !== undefined) {
                                            tmp$3.searchItems = Caml_option.valFromOption(searchItems);
                                          }
                                          return React.createElement("div", {
                                                      key: String(Math.imul(i, 10) + j | 0),
                                                      className: CssJs.style([
                                                            CssJs.borderRight(CssJs.px(1), CssJs.solid, j === 8 || isVisible || isRightVisible ? c1 : c2),
                                                            CssJs.borderBottom(CssJs.px(1), CssJs.solid, i === 8 || isVisible || isBottomVisible ? c1 : c2)
                                                          ])
                                                    }, React.createElement("div", {
                                                          className: isVisible ? "" : "opacity-30"
                                                        }, React.createElement(TbItemCell.make, tmp$3)));
                                        })));
                      })), set !== 120 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data12.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 150 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data15.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 160 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data16.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 170 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data17.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 180 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data18.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 76 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data76.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 140 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data14.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 130 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data13.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 56 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data56.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            }))), set !== 46 ? null : React.createElement("div", {
                        className: "flex"
                      }, Belt_Array.mapWithIndex(Data46.panEmblems, (function (idx, itemId) {
                              var c1 = {
                                NAME: "rgba",
                                VAL: [
                                  255,
                                  255,
                                  255,
                                  {
                                    NAME: "num",
                                    VAL: 0.87
                                  }
                                ]
                              };
                              var tmp = {
                                search: search,
                                itemId: itemId
                              };
                              if (searchItems !== undefined) {
                                tmp.searchItems = Caml_option.valFromOption(searchItems);
                              }
                              return React.createElement("div", {
                                          key: itemId,
                                          className: CssJs.style([
                                                CssJs.borderRight(CssJs.px(1), CssJs.solid, idx === 8 || true || true ? c1 : ({
                                                          NAME: "rgba",
                                                          VAL: [
                                                            255,
                                                            255,
                                                            255,
                                                            {
                                                              NAME: "num",
                                                              VAL: 0.4
                                                            }
                                                          ]
                                                        })),
                                                CssJs.borderBottom(CssJs.px(1), CssJs.solid, c1)
                                              ])
                                        }, React.createElement("div", {
                                              className: ""
                                            }, React.createElement(TbItemCell.make, tmp)));
                            })))));
}

var make = TbCraftableItemsGrid;

export {
  make ,
  
}
/* CssJs Not a pure module */
